import axios from "axios";
import { baseApiUrl, getHttpHeaders, httpRequest } from "./ApiUtils";

const textMessageApiUrl = `${baseApiUrl}/api/TextMessage`;

export async function sendTextMessage(body) {
  return await httpRequest(postTextMessage.bind(this, body));
}

async function postTextMessage(body) {
  let config = getHttpHeaders();
  return await axios.post(`${textMessageApiUrl}`, body, config);
}
